import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: '#FFE8D7',
} as const

export const resources = {
  loginBg: '/images/freefic/login/login-bg.svg',
  logo: '/images/freefic/logo.svg',
  novel: '/images/freefic/wordmark.svg',
  facebookIcon: '/images/freefic/login/icon-facebook-logo.png',
  googleIcon: '/images/freefic/login/icon-google-logo.png',
  appleIcon: '/images/freefic/login/icon-apple-logo.png',
  emailIcon: '/images/freefic/login/icon-email.png',
  emailCodeIcon: '/images/freefic/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: reactive(loginCommonConfig.texts),
}
